import { ServiceRequestConfig } from '~/services/createService';
import { k2 } from '~/services/serviceInstances';

import {
  ListStagesApiResponse,
  StageAttributes,
  StageResponseData,
} from '../../types/k2/ticketStages';

export type Stage = StageAttributes & { id: string };

type Request = {
  ticketId: string;
};
type ServerResponse = ListStagesApiResponse;

export const getStagesK2 = async (
  request: Request,
  options: ServiceRequestConfig = {},
): Promise<Stage[]> => {
  const serverResponse: ServerResponse = await k2.get(
    `/tickets/${request.ticketId}/stages`,
    { showErrorToast: true, ...options },
  );

  return mapResponse(serverResponse);
};

const mapResponse = (serverResponse: ServerResponse): Stage[] => {
  if (!serverResponse?.data?.length) {
    return [];
  }

  return serverResponse.data.map((stageData: StageResponseData) => ({
    id: stageData.id,
    ...stageData.attributes,
  }));
};
